import { Action, applyMiddleware, combineReducers, compose, createStore, ReducersMapObject, Store } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import { BehaviorSubject } from 'rxjs';

import { State } from './models';
import Api from './services/Api';
import Auth from './services/Auth';
import { reducers, rootEpic } from './store';

export default function configureStore(initialState?: State) {
  const auth = new Auth();
  const api = new Api(auth);

  // Build middleware. These are functions that can process the actions before they reach the store.
  const epicMiddleware = createEpicMiddleware<Action, Action, State>({ dependencies: { api } });
  const epic$ = new BehaviorSubject(rootEpic);

  // If devTools is installed, connect to it
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (isDevelopment && typeof window !== 'undefined' && window['__REDUX_DEVTOOLS_EXTENSION__']) {
    enhancers.push(window['__REDUX_DEVTOOLS_EXTENSION__']());
  }

  const createStoreWithMiddleware = compose(applyMiddleware(epicMiddleware), ...enhancers)(createStore);

  // Combine all reducers and instantiate the app-wide store instance
  const allReducers = combineReducers(reducers as unknown as ReducersMapObject<State>);
  const store = createStoreWithMiddleware(allReducers, initialState) as Store<State>;

  epicMiddleware.run(rootEpic);

  if (module.hot) {
    module.hot.accept('./store', () => {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const nextRootEpic = require('./store').rootEpic;
      epic$.next(nextRootEpic);
    });
  }

  return store;
}
